<script lang="ts">
  import { Button } from '@athena-lib/Button';
  import clsx from 'clsx';

  async function setAvatar(data: FormData): Promise<Response> {
    data.append('filename', JSON.stringify((data.get('file') as File).name)); // weird hack to make the server recieve the file
    return await fetch('/account/set_avatar', {
      method: 'POST',
      body: data,
    });
  }

  const {
    src: initialSrc,
    hideButton = false,
    size = 'small',
  }: { src: string | undefined; hideButton?: boolean; size?: 'small' | 'big' } = $props();

  let src = $state(initialSrc);

  let avatarInputValue = $state<FileList | undefined>();
  let avatarInput: HTMLInputElement | undefined = $state(undefined);
  let imgDiv = $state<HTMLDivElement | undefined>();

  $effect(() => {
    if (imgDiv) {
      imgDiv.style.backgroundImage = 'url(' + src + ')';
    }
  });

  function onAvatarInputChange() {
    const maxSize = 8 * 1024 * 1024; // 8MB
    const input = avatarInputValue?.[0];

    if (!input) {
      return;
    }

    if (input.size > maxSize) {
      alert('File size must be less than 8 MB');
      return;
    }

    const formData = new FormData();
    formData.append('file', input);

    setAvatar(formData)
      .then((res) => res.json())
      .then((res) => {
        if (
          typeof res == 'object' &&
          res &&
          'avatarImageUrl' in res &&
          typeof res.avatarImageUrl == 'string'
        ) {
          src = res.avatarImageUrl;
        } else {
          throw new Error('Avatar image URL not found in response data');
        }
      })
      .catch(console.error);
  }
  const sizeClass = $derived.by(() => {
    switch (size) {
      case 'small':
        return 'w-20 h-20';
      case 'big':
        return 'w-32 h-32';
    }
  });
</script>

<div class="relative w-min">
  <input
    type="file"
    class="hidden"
    id="avatar-input"
    accept="image/*"
    bind:files={avatarInputValue}
    onchange={onAvatarInputChange}
    bind:this={avatarInput}
  />

  <Button
    size={'content'}
    class={clsx(
      'p-none absolute bottom-1 right-1 z-[1] h-8 w-8 rounded-full bg-st-black text-st-white',
      hideButton ? 'hidden' : '',
    )}
    color="dark"
    onClick={() => avatarInput?.click()}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="absolute left-2 top-2 text-st-yellow"
      viewBox="0 0 16 16"
    >
      <path
        d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"
      />
    </svg>
  </Button>

  <div
    class={clsx(
      'flex content-center items-center rounded-full bg-cover bg-center shadow-inner',
      sizeClass,
    )}
    id="avatar-img"
    bind:this={imgDiv}
  >
    {#if !src}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="currentColor"
        class="bi text-gray-100"
        viewBox="0 0 16 16"
      >
        <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
        <path
          fill-rule="evenodd"
          d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
        />
      </svg>
    {/if}
  </div>
</div>
